import { CalendarIcon } from 'pages/candidateOfferList/img';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';

import OfferAdditionalAction from './OfferAdditionalAction';

export default function NavigateActionUpdateAvailability() {
    const { t } = useTranslation('candidateOffers');
    const navigate = useNavigate();
    const { search } = useLocation();

    const handleClick = useCallback(() => {
        navigate({
            pathname: APP_ROUTES.candidateAvailability('candidate'),
            search
        });
    }, [ navigate, search ]);

    return <OfferAdditionalAction
        onClick={ handleClick }
        icon={ <CalendarIcon /> }
        iconColor="#41B461"
        text={ t('additionalActions.updateAvailability') }
        description={ t('additionalActions.updateAvailabilityDescription') }
    />;
}
